module.exports = __webpack_public_path__ + "static/media/Study-identifies-quick-and-simple-test-for-salt-levels-in-food_wrbm_large.7cf0d19d.jpg";